import moment from "moment";
class Helper {
  extractAlert(error, from = null) {
    let alert = { type: "error", message: error.message };
    let redirect = "";
    if (error.response?.status === 500) {
      alert = {
        type: "error",
        message: "Something went wrong. Please try again later.",
      };
    } else if (error.response?.status === 404) {
      alert = {
        type: "error",
        message: error.response?.data?.error || "URL Not found",
      };
    } else if (error.response?.status === 401 && from !== "signin") {
      redirect = "signin";
      alert = {
        type: "error",
        message:
          "Oops! Your session has expired. Please log in again to keep going",
      };
    } else if (error.response?.data) {
      let message = "";
      if (typeof error.response.data === "object") {
        const firstKey = Object.keys(error.response.data)[0];
        message = error.response.data?.[firstKey];
        if (Array.isArray(message)) {
          message = message[0];
        }
      } else {
        message = error.response.data;
      }
      alert = {
        type: "error",
        message: message,
      };
    }
    return { alert, redirect };
  }
}

export function getFirstLetter(name) {
  if (!name) {
    return "";
  }
  return name.charAt(0);
}

export function formatDateTime(dateString) {
  if (!dateString) return "-";
  const momentDate = moment(dateString);
  return {
    date: momentDate.format("MM/DD/YYYY"),
    time: momentDate.format("h:mm:ss A"),
  };
}

export function redirectTo(name, id) {
  this.$router.push({
    name: name,
    params: {
      id: id,
    },
  });
}

export function getCountryCode(countries, countryName) {
  if (countryName.length === 2 || countryName.length === 3) {
    return countryName;
  }
  return countries.find((country) => country.country === countryName).code;
}

export default new Helper();
